import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tree from './Tree';

class Organization extends Component {
  renderHeader = () => (
    <div className="PeopleHeader">
      <h1 className="Index-title">
        <span className="PeopleHeader-titleText">
          {t('groups.system_generated.title')}
        </span>
      </h1>
      <p className="PeopleHeader-description">
        {t('groups.system_generated.description')}
      </p>
      <p className="PeopleHeader-description">
        {t('groups.system_generated.directions')}
      </p>
    </div>
  );

  renderTrees = data =>
    data.map(rootNode => (
      <Tree
        updateActiveGroup={this.props.updateActiveGroup}
        updateMyOrganization={this.props.updateMyOrganization}
        data={rootNode}
        root={rootNode.id}
        key={rootNode.id}
      />
    ));

  render() {
    return (
      <>
        {this.renderHeader()}
        {this.renderTrees(this.props.organization)}
      </>
    );
  }
}

const mapStateToProps = state => ({
  organization: state.data.meta.organization,
});

export default connect(mapStateToProps)(Organization);
